import { render } from "./ResidentialDesignProcesses.vue?vue&type=template&id=11dae896&scoped=true"
import script from "../js/residential-design-processes.js?vue&type=script&lang=js"
export * from "../js/residential-design-processes.js?vue&type=script&lang=js"

import "./ResidentialDesignProcesses.vue?vue&type=style&index=0&id=11dae896&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/platinumlandscapemi/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11dae896"]])

export default __exports__